import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const CHECKOUT_URL = process.env.REACT_APP_CHECKOUT_URL;

const MidCTA = ({ text, testid }) => (
  <motion.div
    data-testid={testid}
    className="flex flex-col items-center gap-6 px-6 py-16 sm:py-20"
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
  >
    <div className="hairline w-40" />
    <p className="font-serif-display max-w-xl text-center text-xl italic text-[#A1A1AA] sm:text-2xl">
      {text}
    </p>
    <a
      data-testid={`${testid}-button`}
      href={CHECKOUT_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex items-center justify-center gap-3 rounded-full bg-[#D4AF37] px-8 py-4 text-xs font-bold uppercase tracking-[0.15em] text-[#0A0A0A] transition-all duration-300 hover:bg-[#F3E5AB] hover:shadow-[0_0_40px_rgba(212,175,55,0.3)]"
    >
      Quero meu e-book agora
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
    </a>
    <div className="hairline w-40" />
  </motion.div>
);

export default MidCTA;
